import { ZONE_CONFIGS } from '../../../helpers/general.helpers';
import { palette } from '../../../theme';

export interface WorkoutZoneDisplayConfig {
  label: string;
  zoneIdx: number;
  color: string;
}

/** Z5 → Z0 display order for workout zone breakdown UIs */
export const WORKOUT_ZONE_DISPLAY_CONFIG: WorkoutZoneDisplayConfig[] = [
  { label: 'Zone 5', zoneIdx: 5, color: ZONE_CONFIGS[5].barColor },
  { label: 'Zone 4', zoneIdx: 4, color: ZONE_CONFIGS[4].barColor },
  { label: 'Zone 3', zoneIdx: 3, color: ZONE_CONFIGS[3].barColor },
  { label: 'Zone 2', zoneIdx: 2, color: ZONE_CONFIGS[2].barColor },
  { label: 'Zone 1', zoneIdx: 1, color: ZONE_CONFIGS[1].barColor },
  { label: 'Zone 0', zoneIdx: 0, color: palette.grey[300] },
];

/** Z5 → Z1 only — used by the editable log tab */
export const WORKOUT_LOG_ZONE_DISPLAY_CONFIG = WORKOUT_ZONE_DISPLAY_CONFIG.filter((z) => z.zoneIdx > 0);
